// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RanaFile
 */
export interface RanaFile {
  /**
   *
   */
  id: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  variableType?: RanaFileVariableTypeEnum;
}

/**
 * @export
 */
export const RanaFileVariableTypeEnum = {
  RanaPath: "rana_path",
} as const;
export type RanaFileVariableTypeEnum =
  (typeof RanaFileVariableTypeEnum)[keyof typeof RanaFileVariableTypeEnum];

/**
 * Check if a given object implements the RanaFile interface.
 */
export function instanceOfRanaFile(value: object): value is RanaFile {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function RanaFileFromJSON(json: any): RanaFile {
  return RanaFileFromJSONTyped(json, false);
}

export function RanaFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): RanaFile {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    ref: json["ref"] == null ? undefined : json["ref"],
    variableType: json["variable_type"] == null ? undefined : json["variable_type"],
  };
}

export function RanaFileToJSON(json: any): RanaFile {
  return RanaFileToJSONTyped(json, false);
}

export function RanaFileToJSONTyped(
  value?: RanaFile | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    ref: value["ref"],
    variable_type: value["variableType"],
  };
}
